var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-card",class:{
    'title-card--large': _vm.data.type === 'large',
  }},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }